<template lang="html">
  <transition name="fade">
    <div class="card mt-5 mb-5 shadow notification-card" v-if="showCard">
      <div class="card-body">
        <b-link
          class="dismiss-alert-notification float-right"
          right
          @click.prevent="dismissNotification"
        >
          <i class="pe-7s-close close-icon"></i>
        </b-link>
        <h4 class="card-title">Hi! 👋</h4>
        <p class="card-text card-text-discord mt-4 mb-4">
          Wondering where to start? Why not
          <strong>build your first capsule</strong> and share it with the
          community?
        </p>
        <b-button
          size="lg"
          variant="outline-unstitched"
          class="connect-btn"
          @click.prevent="submitCreateCapsule"
          :disabled="creatingCapsule"
        >
          Build your first capsule
          <b-spinner small class="ml-1" v-if="creatingCapsule"></b-spinner>
        </b-button>
        <b-button
          variant="link"
          class="dismiss-notification-btn"
          @click.prevent="dismissNotification"
        >
          Not now
        </b-button>
      </div>
    </div>
  </transition>
</template>

<script>
import cookies from "js-cookie";
import { mapActions } from "vuex";

export default {
  components: {},

  mounted() {
    const cookie = cookies.get("_unstitched_create_capsule_card");
    if (cookie !== "true") this.showCard = true;
  },

  data() {
    return {
      creatingCapsule: false,
      showCard: false,
    };
  },

  methods: {
    ...mapActions(["createCapsule"]),

    submitCreateCapsule() {
      this.creatingCapsule = true;
      const payload = { title: null, occasion: null, notes: null, link: null };
      this.createCapsule(payload);
    },

    dismissNotification() {
      this.showCard = false;
      cookies.set("_unstitched_create_capsule_card", true, { expires: 2 });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.notification-card {
  border: 0;
  background-image: linear-gradient(
    -225deg,
    #dfffcd 0%,
    #90f9c4 48%,
    #39f3bb 100%
  );

  .dismiss-alert-notification {
    position: absolute;
    right: 5px;
    top: 0;
    font-size: 2.5rem;
    color: white;

    &:hover {
      i {
        font-weight: 600;
      }
    }
  }

  .connect-btn,
  .dismiss-notification-btn {
    text-transform: initial;
    font-size: 0.8rem;
  }

  .connect-btn {
    background-color: $primary-accent;
    border-color: $primary-accent;

    &:hover,
    &:focus {
      color: $primary-blue;
    }
  }

  .dismiss-notification-btn {
    color: $grey1;
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/discover/NotificationCard.vue